import React from 'react';
import { Dropdown } from '../../../../components/Dropdown';
import { IconSpan } from '../../../../components/IconSpan';
import { ScorecardTemplateService } from '../../../../services/applicant_tracking/ScorecardTemplateService';

interface PropTypes {
  scorecardTemplateId: number;
  showScorecardTemplateUrl: string;
  deleteEnabled: boolean;
}

function buildMenuAction(
  action: () => void,
  label: string,
  iconName: string,
  enabled: boolean,
) {
  if (!enabled) return null;

  return {
    action: action,
    buttonChild: (
      <IconSpan
        spanText={label}
        icon={{ name: iconName, className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

export default function RowActionsDropdown(props: PropTypes) {
  return (
    <Dropdown
      buttonIcon={{
        name: 'bi-three-dots',
        className: 'fs-4 text-info',
      }}
      menuPlacementClass={'dropdown-menu-end'}
      menuActions={[
        buildMenuAction(
          () => (window.location.href = props.showScorecardTemplateUrl),
          'View',
          'bi-eye',
          true,
        ),
        buildMenuAction(
          () => {
            (async () => {
              await ScorecardTemplateService.delete(props.scorecardTemplateId);
              window.location.reload();
            })();
          },
          'Delete',
          'bi-trash',
          props.deleteEnabled,
        ),
      ].filter((a) => a != null)}
    />
  );
}
